import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps } from '../common/props';

type Props = BaseProps & {
  // Pokud je true, tlačítka jsou linky a ne tlačítka, pak při hover na celou skupinu se zobrazí hover efekt.
  linkButtons?: boolean;
};

/**
 * Skupina více tlačítek, která je logicky jako jeden celek, typicky se používá na tlačítko s dropdown kde je možné klikat samostatně na tlačítko (dělá akci) nebo na dropdown (ostatní akce, které jsou méně časté).
 */
export const ButtonGroup: React.FC<Props> = ({
  className,
  linkButtons,
  children,
  ...other
}) => {
  let cls = classNames(className, Classes.BUTTON_GROUP, {
    [Classes.BUTTON_GROUP_LINK_BUTTONS]: linkButtons,
  });

  return (
    <div className={cls} {...other}>
      {children}
    </div>
  );
};
